<ig-field #trigger [label]="label" [icon]="icon" [readonly]="true" [(ngModel)]="fieldValue" [disabled]="disabled"
    (onIconClick)="trigger.input.nativeElement.click()" [formControl]="formGroup.get('input')">
</ig-field>

<div class="drop-down-container" #container [class.show]="isShowing">
    <div item *ngFor="let item of value" (click)="select(item)">{{item.text}}</div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/select/select.component.html